import { BarChart3 } from 'lucide-react';

/**
 * PollBubble — single-choice poll with progress bars. Tap an option to vote
 * (toggles off if you re-tap the same option). Server returns updated votes.
 */
export default function PollBubble({ poll, currentUserId, isMine, onVote }) {
  if (!poll) return null;
  const votes = poll.votes || {};
  const totalVotes = Object.values(votes).reduce((s, arr) => s + (arr?.length || 0), 0);
  const myVote = Object.entries(votes).find(([, uids]) => uids.includes(currentUserId))?.[0] || '';

  const handle = (e, optId) => {
    e.stopPropagation();
    onVote?.(optId);
  };

  return (
    <div
      className={`rounded-2xl px-3 py-2.5 mb-1 w-[280px] max-w-full ${isMine ? 'bg-[#3F5200]/8' : 'bg-[#F1F0EA]'} border border-black/[0.04]`}
      data-testid="poll-bubble"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="flex items-center gap-1.5 mb-2">
        <BarChart3 size={12} className="text-[#6B8A00]" />
        <span className="text-[10px] font-bold uppercase tracking-wider text-[#6B8A00]">Poll</span>
      </div>
      <p className="text-sm font-bold text-[#111111] leading-tight mb-2.5 break-words">{poll.question}</p>
      <div className="space-y-1.5">
        {poll.options.map(opt => {
          const count = (votes[opt.id] || []).length;
          const pct = totalVotes > 0 ? Math.round((count / totalVotes) * 100) : 0;
          const mine = myVote === opt.id;
          return (
            <button
              type="button"
              key={opt.id}
              onClick={(e) => handle(e, opt.id)}
              data-testid={`poll-option-${opt.id}`}
              className={`relative w-full rounded-xl overflow-hidden text-left transition-all active:scale-[0.98] ${mine ? 'ring-2 ring-[#B6E600]' : ''}`}
            >
              <div
                className={`absolute inset-y-0 left-0 ${mine ? 'bg-[#B6E600]/35' : 'bg-white'} transition-all duration-300`}
                style={{ width: `${Math.max(pct, 12)}%` }}
              />
              <div className={`relative flex items-center justify-between px-3 py-2 ${mine ? '' : 'bg-white/60'}`}>
                <span className="text-xs font-semibold text-[#111111] truncate pr-2">{opt.text}</span>
                <span className="text-[11px] font-bold text-[#3F5200] tabular-nums">{pct}%</span>
              </div>
            </button>
          );
        })}
      </div>
      <p className="text-[10px] text-[#9B9EA3] mt-2">{totalVotes} vote{totalVotes === 1 ? '' : 's'}</p>
    </div>
  );
}
